import { SUPER_ADMIN } from "@/components/data/constants";
import { useActiveSession } from "@/hooks/useActiveSession";
import { SERVENGINE_SCOPE, useEntityTenantStore } from "@/store/entityTenantStore";

/**
 * True only for a super admin who is currently in the ServEngine scope (no
 * entity picked in the label menu). Forms created here belong to the platform
 * tenant and are the only ones a "global" (all-entities) form can come from.
 */
export function useIsServEngineSuperAdmin(): boolean {
  const { userType } = useActiveSession();
  const entityTenant = useEntityTenantStore((state) => state.entityTenant);
  return userType === SUPER_ADMIN && entityTenant === SERVENGINE_SCOPE;
}
